import {
  type AxiosLikeFetchResponse,
  createAxiosLikeFetch,
} from '@devhacker/shared/libs/fetch/createAxiosLikeFetch';
import { createLoggerInterceptors } from '@devhacker/shared/libs/logger';
import { SPECIAL_API_URL } from '~/constants/config';
import { API_TIMEOUT } from '@devhacker/shared/config/general';

export interface ISpecialApi {
  askQuestion: (
    user_id: number,
    name: string,
    text: string,
  ) => Promise<AxiosLikeFetchResponse<object>>;
}

export const createSpecialApi = ({ $logger }: any): ISpecialApi => {
  const searchFetch = createAxiosLikeFetch({
    baseURL: SPECIAL_API_URL,
    timeout: API_TIMEOUT,
    parseResponse: JSON.parse, // без этого API может вернуть 200 код и html
    ...createLoggerInterceptors($logger, 'special'),
  });

  return {
    askQuestion: (user_id, name, text) => {
      const url = '/api/asklh/question-post';
      return searchFetch(url, {
        method: 'post',
        body: { user_id, name, text },
      });
    },
  };
};
